import { render, staticRenderFns } from "./employee-group-header-factory.vue?vue&type=template&id=8fee2912&scoped=true"
import script from "./employee-group-header-factory.vue?vue&type=script&lang=js"
export * from "./employee-group-header-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fee2912",
  null
  
)

export default component.exports